'use strict'

const mkdirp = require('mkdirp')

module.exports = function (dir, opts) {
  return new Promise((resolve, reject) => {
    mkdirp(dir, opts, (err, made) => err === null ? resolve(made) : reject(err))
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/mkdirp-promise/lib/index.js
// module id = 374
// module chunks = 0 1 2 3